import { Box, IconButton } from '@mui/material';
import PauseIcon from 'mdi-react/PauseIcon';
import PlayIcon from 'mdi-react/PlayIcon';
import { bool, func } from 'prop-types';
import React from 'react';

const PlayButton = ({ paused, loaded, onClick, right }) => (
  <IconButton disabled={!loaded} onClick={onClick} aria-label="play" size="large">
    <Box
      sx={theme => ({
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '100px',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.white,
        ...(right && {
          backgroundColor: theme.palette.white,
          color: theme.palette.secondary.main,
        }),
        ...(!loaded && {
          color: theme.palette.secondary.extraLight,
          backgroundColor: theme.palette.secondary.light,
          ...(right && {
            backgroundColor: theme.palette.secondary.extraLight,
            color: theme.palette.secondary.light,
          }),
        }),
      })}
    >
      {paused ? <PlayIcon style={{ fontSize: 10 }} /> : <PauseIcon style={{ fontSize: 10 }} />}
    </Box>
  </IconButton>
);

PlayButton.propTypes = {
  right: bool.isRequired,
  paused: bool.isRequired,
  loaded: bool.isRequired,
  onClick: func.isRequired,
};

export default PlayButton;
